import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LinkService {
    public openLink(url: string): void {
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
    }
}
